import { render, staticRenderFns } from "./StaffSidePreview.vue?vue&type=template&id=67b1a374&scoped=true&"
import script from "./StaffSidePreview.vue?vue&type=script&lang=js&"
export * from "./StaffSidePreview.vue?vue&type=script&lang=js&"
import style0 from "./StaffSidePreview.vue?vue&type=style&index=0&id=67b1a374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b1a374",
  null
  
)

export default component.exports